import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Element } from 'react-scroll'
import MasterData from '../../data/MasterData'
import TrainLaneData from '../../data/TrainLaneData'
import Train from '../../containers/Train'
import Modal from 'react-modal';
import images from '../../assets/images/home_stationnumber/*.svg'
import home_images from '../../assets/images/home/*.svg'

const customStyles = {
  content : {
    background: 'initial',
    overflow : 'initial',
    border : '0px',
    position : 'initial',
    padding : '0px',
  },
  overlay : {
    backgroundColor:'initial',
    position : 'fixed',
  }
};

export default class TrainPositionStationRow extends React.Component {
  static propTypes = {
    lineName: PropTypes.string.isRequired,
    lines: PropTypes.array.isRequired,
    station: PropTypes.object,
    trains: PropTypes.array.isRequired,
    themeName: PropTypes.string.isRequired,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  lineId() {
    const { lineName } = this.props
    return MasterData.lineIdByLineName(lineName)
  }

  trainKind(lineId, trainNumber) {
    const trainKind = MasterData.trainKindByLineIdAndTrainNumber(lineId, trainNumber)
    if (trainKind !== undefined) {
      return trainKind.kind
    }

    return null
  }

  // nextStationId に向かっている営業運転列車を返す
  trainsToward(direction, lane, count) {
    const { station, trains, lineName } = this.props
    if (!station) return []
    var tmp_trains = trains.filter(train => (
      train.station_id === station.id &&
      train.next_station_id &&
      train.direction === direction &&
      lane === TrainLaneData.getByStationIdAndTrainNumber(station.id, train.train_number.substr(0,2).toString()) &&
      this.trainKind(MasterData.lineIdByLineName(lineName), train.train_number)
    ))
    if (tmp_trains.length < count){
      return tmp_trains.sort((a, b) => {
        // positionは次駅に近い方から昇順に設定されているので、上りでは昇順、下りでは降順にソートする
        if (direction === 'up') {
          return a.position - b.position;
        } else {
          return b.position - a.position;
        }
      });
    } else {
      tmp_trains[0]["duplicate"] = true
      return tmp_trains
    }
  }

  // 駅の指定された方向に止まっている電車を返す
 trainsOnStation(direction, lane, count) {
  const { station, trains, lineName } = this.props
  if (!station) return []
  var tmp_trains = trains.filter(train => (
    train.station_id === station.id &&
    !train.next_station_id &&
    train.direction === direction &&
    lane === TrainLaneData.getByStationIdAndTrainNumber(station.id, train.train_number.substr(0,2).toString()) &&
    this.trainKind(MasterData.lineIdByLineName(lineName), train.train_number)
  ))
  if (tmp_trains.length < count){
    return tmp_trains.sort((a, b) => {
      // positionは次駅に近い方から昇順に設定されているので、上りでは昇順、下りでは降順にソートする
      if (direction === 'up') {
        return a.position - b.position;
      } else {
        return b.position - a.position;
      }
    });
  } else {
    tmp_trains[0]["duplicate"] = true
    return tmp_trains
  }
}

  renderTrain(trains) {
    const { lineName, match, history } = this.props
    let train = trains.shift()
    return <Train
      {...this.props}
      key={`train${train.train_number}`}
      train={train}
      duplicateTrains={trains}
      lineName={lineName}
      match={match}
      history={history}
    />
  }

  stationKind() {
    const { station } = this.props
    return MasterData.stationKind(station.id)
  }

  lineKind() {
    const { station } = this.props
    return MasterData.lineKind(station.id)
  }

  lineSignal() {
    const { station } = this.props
    return MasterData.lineSignal(station.id)
  }

  lineSwitch() {
    const { station } = this.props
    return MasterData.lineSwitch(station.id)
  }

  renderLineElement() {
    const { lineName } = this.props

    switch(this.stationKind()) {
      case 'start':
      return (
        <div className="d-TrainPosition-line">
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} is_line_start`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
        </div>
        )
      case 'none':
        return null
      case 'branchEnd':
        return <div className="d-TrainPosition-line is_branch_end"></div>
      case 'transfer':
        return (
        <div className="d-TrainPosition-line">
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} is_transfer_line`}></div>        
        </div>
        )
        case 'kadaBranch':
        return (
        <div className="d-TrainPosition-line">
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} is_kada is_branch_line`}></div>        
        </div>
        )
      default:
        return (
        <div className="d-TrainPosition-line">
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} ${this.lineSignal()}`}></div>
        </div>
        )
    }
  }

  renderAdditionalElement() {
    switch(this.stationKind()) {
      case 'branchStart':
        return <div className="d-TrainPosition-line is_branch_start"></div>
    }
  }

  renderStationName() {
    const { station, lineName, themeName } = this.props
    const image_url = `home_${lineName}_stationnumber_nk${station.eki_number}`

    return(
      <div className="d-TrainPosition-stationNumber">
        <Link to={`/lines/${lineName}/stations/${station.id}`}>
          <img src={images[image_url]} />
        </Link>
      </div>
    )
  }

  renderLineSwitch() {
    const { station, lineName } = this.props
    if (!station.transfer) return null

    return(
      <a className="d-TrainPosition-lineSwitchLink">
        <ul onClick={this.openModal} className="d-TrainPosition-lineSwitchList">
          {this.props.lineSwitchItem(station)}
        </ul>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick={true}
          style={customStyles}
        >
          <div key={station.id} className={`c-Modal -size-sm -upper-layer is_${lineName}`}>
            <div className="c-Modal-dialog">
              <div className="c-Modal-header">
                <p className="c-Modal-headerTitle" >乗り換え案内</p>
                <a onClick={this.closeModal}><div className="c-Modal-headerClose"></div></a>
              </div>
              <div className="c-Modal-transfer">
                <ul className="c-Modal-transferList">
                  {this.props.transferList(station)}
                </ul>
              </div>
            </div>
          </div>
        </Modal>
      </a>
    )
  }

  // trainsFilteringFunction: 列車を返す関数
  // direction: 方向
  renderTrainPositionBlockRow(trainsFilteringFunction, direction) {
    // 描画する blockRow がのぼり方向（direction === 'up'）なら、'outer', 'inner'の順番で描画する
    // 描画する blockRow がくだり方向（direction === 'down）なら、'inner', 'outer'の順番で描画する
    //var count = this.lineSignal() ? 4 : 3
    var count = 3
    var outer_trains = trainsFilteringFunction(direction, direction === 'up' ? 'outer' : 'inner', count)
    var inner_trains = trainsFilteringFunction(direction, direction === 'up' ? 'inner' : 'outer', count)
    return(
      <div className={`d-TrainPosition-blockRow is_${direction}`}>
        <div className="d-TrainPosition-blockItem">
          {outer_trains.length < count ? outer_trains.map(train => this.renderTrain([train])):(this.renderTrain(outer_trains))}
        </div>

        <div className="d-TrainPosition-blockItem">
          {inner_trains.length < count ? inner_trains.map(train => this.renderTrain([train])):(this.renderTrain(inner_trains))}
        </div>
      </div>
    )
  }

  // trainsFilteringFunction: 列車を返す関数
  // direction: 方向
  renderStationTrainPositionBlockRow(trainsFilteringFunction, direction) {
    // 描画する blockRow がのぼり方向（direction === 'up'）なら、'outer', 'inner'の順番で描画する
    // 描画する blockRow がくだり方向（direction === 'down）なら、'inner', 'outer'の順番で描画する
    var count = 2
    var outer_trains = trainsFilteringFunction(direction, direction === 'up' ? 'outer' : 'inner', count)
    var inner_trains = trainsFilteringFunction(direction, direction === 'up' ? 'inner' : 'outer', count)
    return(
      <div className={`d-TrainPosition-blockRow is_${direction} is_on_station`}>
        <div className="d-TrainPosition-blockItem">
          {outer_trains.length < count ? outer_trains.map(train => this.renderTrain([train])):(this.renderTrain(outer_trains))}
        </div>

        <div className="d-TrainPosition-blockItem">
          {inner_trains.length < count ? inner_trains.map(train => this.renderTrain([train])):(this.renderTrain(inner_trains))}
        </div>
      </div>
    )
  }

  render() {
    return (
      <li className="d-TrainPosition-stationItem">
        <Element id={`station${this.props.station.id}`} className={`d-TrainPosition-anchorlink`} />
        {this.renderStationName()}
        {this.renderLineSwitch()}
        {this.renderLineElement()}
        {this.renderAdditionalElement()}

        <div className="d-TrainPosition-block">
          {/* 駅の上に停車中 & 上り */}
          {this.renderStationTrainPositionBlockRow(this.trainsOnStation.bind(this), 'up')}

          {/* 駅の上に停車中 & くだり */}
          {this.renderStationTrainPositionBlockRow(this.trainsOnStation.bind(this), 'down')}

          {/* 駅間に停車中 & 上り */}
          {this.renderTrainPositionBlockRow(this.trainsToward.bind(this), 'up')}

          {/* 駅間に停車中 & くだり */}
          {this.renderTrainPositionBlockRow(this.trainsToward.bind(this), 'down')}

        </div>

      </li>
    )
  }
}
